export const environment = {
     production:false,
     NODE_ENV:"qa",
     BASE_URL:"",
     APP_PRE_PEND:"",
     APP_API_URL:"https://web-api.poc.psp.cdc.nicusa.com",
     APP_CDB_URL:"https://cdb-uat.cdc.nicusa.com/dot/cust-admin/login.html",
     APP_PSP_OLD_BASE_URL:"https://poc.psp.cdc.nicusa.com",
     APP_PSP_BASE_URL:"https://poc.psp.cdc.nicusa.com",
     APP_PSP_DOC_BASE_URL:"https://web-api.poc.psp.cdc.nicusa.com/Documents",
     APP_PSP_CDB_URL:"https://cdb-uat.cdc.nicusa.com/dot/",
     APP_PSP_NEXT_URL:"https://csr.poc.psp.cdc.nicusa.com/",
     APP_CDB_API_URL:"https://web-api.poc.psp.cdc.nicusa.com/api/v1",
     OUTPUT_DIR:"dist/",
     APP_WHOSON_URL : "//hostedusa1.whoson.com/include.js?domain:psp-stage.cdc.nicusa.com",
     APP_WHOSON_DOMAIN : "psp-stage.cdc.nicusa.com",
     APP_WHOSON_CHAT_START : "https://hostedusa1.whoson.com/newchat/chat.aspx",
     APP_WHOSON_SESSION : "hostedusa1.whoson.com",
     APP_GOOGLE_ANALYTICS_KEY:"UA-13204035-3",
     APP_GA4_MEASUREMENT_ID : "G-4DF3H4QXP5",
     APP_TRANSLATE_LN:"true",
     APP_DRIVER_RECORD_EXPIRATION_HOURS:"120",
     APP_LOGIN_GOV_CLIENT_ID:"urn:gov:gsa:openidconnect.profiles:sp:sso:dot:psp",
     APP_LOGIN_GOV_LOGOFF_URL:"https://idp.int.identitysandbox.gov/openid_connect/logout"
}